// components/RoleProtectedRoute.tsx
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

interface RoleProtectedRouteProps {
  allowedRoles?: string[];
  excludedRoles?: string[];
  redirectTo?: string;
}

const RoleProtectedRoute = ({ 
  allowedRoles = [], 
  excludedRoles = [], 
  redirectTo = '/' 
}: RoleProtectedRouteProps) => {
  const { user, isAuthenticated } = useAuthStore();
  
  // If not authenticated, redirect to login
  if (!isAuthenticated || !user) {
    console.log('RoleProtectedRoute: Not authenticated or no user');
    return <Navigate to="/login" replace />;
  }
  
  // Debug logging
  console.log('RoleProtectedRoute - User role:', user.role);
  console.log('RoleProtectedRoute - Allowed roles:', allowedRoles);
  console.log('RoleProtectedRoute - Excluded roles:', excludedRoles);
  
  // Check if user role is in excluded roles
  if (excludedRoles.length > 0 && excludedRoles.includes(user.role)) {
    console.log(`RoleProtectedRoute: User role ${user.role} is excluded, redirecting to ${redirectTo}`);
    return <Navigate to={redirectTo} replace />;
  }
  
  // Check if user role is in allowed roles (if specified)
  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    console.log(`RoleProtectedRoute: User role ${user.role} not in allowed roles, redirecting to ${redirectTo}`);
    return <Navigate to={redirectTo} replace />;
  }
  
  // User has access
  console.log('RoleProtectedRoute: Access granted');
  return <Outlet />;
};

export default RoleProtectedRoute;